import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useSelector } from 'react-redux';
import { useApiMutation } from './useApiMutation';

const useUserEventsByTypesAndTimeRange = (options = {}) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiMutation(
    ({
      useruuid,
      startDateTimeUTC,
      endDateTimeUTC,
      eventTypes = [],
      successCallback,
      errorCallback,
    }) =>
      new Promise((resolve, reject) => {
        userEventsApi.userEventsByTypesAndTimeRange(
          useruuid,
          startDateTimeUTC,
          endDateTimeUTC,
          { eventtypes: eventTypes, details: true },
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              successCallback(data['user_events'] || []);
              resolve(data['user_events'] || []);
            },
            errorCallback: (err) => {
              console.error(`Error fetching ${eventTypes.join(',')} events data: `, err);
              errorCallback(err);
              reject(err);
            },
            failCallback: (err) => {
              console.error(`Failed to fetch ${eventTypes.join(',')} events data: `, err);
              errorCallback(err);
              reject(err);
            },
          })
        );
      }),
    { ...options }
  );
};

export default useUserEventsByTypesAndTimeRange;
